export const GEOLOCATION_COOKIE_SERVICE = "GeolocationCookieService";
